import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about.vue')
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: () => import('@/views/portfolio.vue')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/contact.vue')
  },
  {
    path: '/description',
    name: 'Full-description',
    component: () => import('@/views/fullDescription.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router;
